import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { NumberPipe } from "../ndm/pipes/number.pipe";
import { Refresh_datasetComponent } from "../ndm/view_data/refresh_dataset/refresh_dataset.component";
import { LoaderComponent } from "./loader/loader.component";
import { LoaderService } from "./loader/loader.service";

@NgModule({
    declarations: [
      LoaderComponent, 
      NumberPipe,
      Refresh_datasetComponent
    ],
    imports: [FormsModule,
      ReactiveFormsModule,
      CommonModule, RouterModule, 
      FormsModule,
    ],
    exports: [
      LoaderComponent,
      NumberPipe,
      Refresh_datasetComponent
    ],
    providers: [LoaderService, NumberPipe
    ],
    // entryComponents: [
    // ],
  })
  export class SharedModule { }
  